import { useQuery } from "react-query";
import { PagedRequestType } from "../types/PagedResults";
import { Key_subscriptions } from "../utils/constants";
import { getSubscriptions, getSubscriptionSubjectsInClass } from "../services/school/student/getSubscriptions";

export const useGetSubscriptionsQuery = (pagedRequest?: PagedRequestType,options:any= null) => {
    return useQuery([Key_subscriptions, JSON.stringify(pagedRequest)], () => getSubscriptions(pagedRequest),options?{...options}:{});
  };
